import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2020-12-07
	search(params) {
		return axios.get('/settlements?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},

	// 2020-12-08
	findByTitle(params) {
		return axios.get('/settlements/find-by-title', params)
	},
	// 2020-12-08
	create(params) {
		return axios.post('/settlements', params)
	},
	// 2020-12-08
	update(id, params) {
		return axios.put('/settlements/' + id, params)
	},
	// 2020-12-08
	delete(id) {
		return axios.delete('/settlements/' + id)
	},
	// 2020-12-08
	verify(id) {
		return axios.put('/settlements/' + id + '/verify');
	},
	// 2021-04-21
	selfVerify(id) {
		return axios.put('/settlements/' + id + '/self-verify');
	},
	// 2020-12-08
	payOff(id) {
		return axios.put('/settlements/' + id + '/payoff');
	},

	// 2020-12-08
	items(id, params) {
		return axios.get('/settlements/' + id + '/items', params)
	},
	// 2020-12-08
	updateItem(id, itemId, params) {
		return axios.put('/settlements/' + id + '/items/' + itemId, params);
	},
	// 2021-01-19
	updateVerifyExplain(id, itemId, params) {
		return axios.put('/settlements/' + id + '/items/' + itemId + '/update-verify-explain', params);
	},
	// 2020-12-08
	deleteItem(id, itemId) {
		return axios.delete('/settlements/' + id + '/items/' + itemId);
	},
	// 2020-12-08
	verifyItem(id, itemId) {
		return axios.put('/settlements/' + id + '/items/' + itemId + '/verify');
	},
	// 2020-12-08
	exportExcelItem(params) {
		return axios.get('/settlements/items/export-excel', params)
	},
	// 2021-04-21
	selfVerifyItem(id, itemId) {
		return axios.put('/settlements/' + id + '/items/' + itemId + '/self-verify');
	},
	// 2021-04-21
	updateSelfVerifyExplain(id, itemId, params) {
		return axios.put('/settlements/' + id + '/items/' + itemId + '/update-self-verify-explain', params);
	},

	// 2021-12-20
	selfMarkError(id, itemId, params) {
		return axios.put('/settlements/' + id + '/items/' + itemId + '/self-mark-error', params);
	},
	// 2021-12-20
	markError(id, itemId, params) {
		return axios.put('/settlements/' + id + '/items/' + itemId + '/mark-error', params);
	},
	// 2021-07-30
	orderChecking(id) {
		return axios.get('/settlements/' + id + '/order-checking');
	},
	// 2021-07-30
	purchaseChecking(id) {
		return axios.get('/settlements/' + id + '/purchase-checking');
	},
	// 2021-08-18
	supplierCount(id) {
		return axios.get('/settlements/supplier-count');
	},
	//Mes=====
	// 2020-12-27
	searchMes(params) {
		return axios.get('/mes/settlements?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-27
	updateMes(id, params) {
		return axios.put('/mes/settlements/' + id, params)
	},
	// 2020-12-27
	deleteMes(id) {
		return axios.delete('/mes/settlements/' + id)
	},
	// 2020-12-27
	createMes(params) {
		return axios.post('/mes/settlements', params)
	},
	// 2020-12-27
	findByTitleMes(params) {
		return axios.get('/mes/settlements/find-by-title', params)
	},
	// 2020-12-27
	findByIdMes(id) {
		return axios.get('/mes/settlements/' + id)
	},
	//mms=====
	// 2021-03-12
	searchMms(params) {
		return axios.get('/mms/settlements?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-03-12
	findByTitleMms(params) {
		return axios.get('/mms/settlements/find-by-title', params)
	},
	// 2021-03-12
	updateMms(id, params) {
		return axios.put('/mms/settlements/' + id, params)
	},
	// 2021-03-12
	deleteMms(id) {
		return axios.delete('/mms/settlements/' + id)
	},
	// 2021-03-12
	createMms(params) {
		return axios.post('/mms/settlements', params)
	},
	// 2021-03-12
	findByIdMms(id) {
		return axios.get('/mms/settlements/' + id)
	},
	//=====
	// 2020-12-08
	findById(id) {
		return axios.get('/settlements/' + id)
	},
}